export default "__VITE_ASSET__CXErG$1a__"